import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';
import React from 'react';

import { useAuth } from '@/shared/contexts/AuthContext';

import ProtectedRoutes from './ProtectedRoutes';

/**
 * Route guard for admin-only pages. Wraps ProtectedRoutes (authentication +
 * profile check) and adds an isAdmin role check. Non-admin users are
 * redirected to the dashboard.
 */
const AdminRoutes = ({ children }) => {
    const { isAdmin, profileLoading } = useAuth();

    return (
        <ProtectedRoutes>
            {profileLoading ? (
                <div className="d-flex justify-content-center p-5">
                    <Spinner animation="border" variant="primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </Spinner>
                </div>
            ) : !isAdmin ? (
                <Navigate to="/dashboard" replace />
            ) : (
                children
            )}
        </ProtectedRoutes>
    );
};

AdminRoutes.propTypes = {
    children: PropTypes.node.isRequired,
};

export default AdminRoutes;
